/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "ko-KP": {
        "nu": ["latn"],
        "year": {
          "0": "올해",
          "1": "내년",
          "future": {
            "other": "{0}년 후"
          },
          "past": {
            "other": "{0}년 전"
          },
          "-1": "작년"
        },
        "year-short": {
          "0": "올해",
          "1": "내년",
          "future": {
            "other": "{0}년 후"
          },
          "past": {
            "other": "{0}년 전"
          },
          "-1": "작년"
        },
        "year-narrow": {
          "0": "올해",
          "1": "내년",
          "future": {
            "other": "{0}년 후"
          },
          "past": {
            "other": "{0}년 전"
          },
          "-1": "작년"
        },
        "quarter": {
          "0": "이번 분기",
          "1": "다음 분기",
          "future": {
            "other": "{0}분기 후"
          },
          "past": {
            "other": "{0}분기 전"
          },
          "-1": "지난 분기"
        },
        "quarter-short": {
          "0": "이번 분기",
          "1": "다음 분기",
          "future": {
            "other": "{0}분기 후"
          },
          "past": {
            "other": "{0}분기 전"
          },
          "-1": "지난 분기"
        },
        "quarter-narrow": {
          "0": "이번 분기",
          "1": "다음 분기",
          "future": {
            "other": "{0}분기 후"
          },
          "past": {
            "other": "{0}분기 전"
          },
          "-1": "지난 분기"
        },
        "month": {
          "0": "이번 달",
          "1": "다음 달",
          "future": {
            "other": "{0}개월 후"
          },
          "past": {
            "other": "{0}개월 전"
          },
          "-1": "지난달"
        },
        "month-short": {
          "0": "이번 달",
          "1": "다음 달",
          "future": {
            "other": "{0}개월 후"
          },
          "past": {
            "other": "{0}개월 전"
          },
          "-1": "지난달"
        },
        "month-narrow": {
          "0": "이번 달",
          "1": "다음 달",
          "future": {
            "other": "{0}개월 후"
          },
          "past": {
            "other": "{0}개월 전"
          },
          "-1": "지난달"
        },
        "week": {
          "0": "이번 주",
          "1": "다음 주",
          "future": {
            "other": "{0}주 후"
          },
          "past": {
            "other": "{0}주 전"
          },
          "-1": "지난주"
        },
        "week-short": {
          "0": "이번 주",
          "1": "다음 주",
          "future": {
            "other": "{0}주 후"
          },
          "past": {
            "other": "{0}주 전"
          },
          "-1": "지난주"
        },
        "week-narrow": {
          "0": "이번 주",
          "1": "다음 주",
          "future": {
            "other": "{0}주 후"
          },
          "past": {
            "other": "{0}주 전"
          },
          "-1": "지난주"
        },
        "day": {
          "0": "오늘",
          "1": "내일",
          "2": "모레",
          "future": {
            "other": "{0}일 후"
          },
          "past": {
            "other": "{0}일 전"
          },
          "-2": "그저께",
          "-1": "어제"
        },
        "day-short": {
          "0": "오늘",
          "1": "내일",
          "2": "모레",
          "future": {
            "other": "{0}일 후"
          },
          "past": {
            "other": "{0}일 전"
          },
          "-2": "그저께",
          "-1": "어제"
        },
        "day-narrow": {
          "0": "오늘",
          "1": "내일",
          "2": "모레",
          "future": {
            "other": "{0}일 후"
          },
          "past": {
            "other": "{0}일 전"
          },
          "-2": "그저께",
          "-1": "어제"
        },
        "hour": {
          "0": "현재 시간",
          "future": {
            "other": "{0}시간 후"
          },
          "past": {
            "other": "{0}시간 전"
          }
        },
        "hour-short": {
          "0": "현재 시간",
          "future": {
            "other": "{0}시간 후"
          },
          "past": {
            "other": "{0}시간 전"
          }
        },
        "hour-narrow": {
          "0": "현재 시간",
          "future": {
            "other": "{0}시간 후"
          },
          "past": {
            "other": "{0}시간 전"
          }
        },
        "minute": {
          "0": "현재 분",
          "future": {
            "other": "{0}분 후"
          },
          "past": {
            "other": "{0}분 전"
          }
        },
        "minute-short": {
          "0": "현재 분",
          "future": {
            "other": "{0}분 후"
          },
          "past": {
            "other": "{0}분 전"
          }
        },
        "minute-narrow": {
          "0": "현재 분",
          "future": {
            "other": "{0}분 후"
          },
          "past": {
            "other": "{0}분 전"
          }
        },
        "second": {
          "0": "지금",
          "future": {
            "other": "{0}초 후"
          },
          "past": {
            "other": "{0}초 전"
          }
        },
        "second-short": {
          "0": "지금",
          "future": {
            "other": "{0}초 후"
          },
          "past": {
            "other": "{0}초 전"
          }
        },
        "second-narrow": {
          "0": "지금",
          "future": {
            "other": "{0}초 후"
          },
          "past": {
            "other": "{0}초 전"
          }
        }
      },
      "ko": {
        "nu": ["latn"],
        "year": {
          "0": "올해",
          "1": "내년",
          "future": {
            "other": "{0}년 후"
          },
          "past": {
            "other": "{0}년 전"
          },
          "-1": "작년"
        },
        "year-short": {
          "0": "올해",
          "1": "내년",
          "future": {
            "other": "{0}년 후"
          },
          "past": {
            "other": "{0}년 전"
          },
          "-1": "작년"
        },
        "year-narrow": {
          "0": "올해",
          "1": "내년",
          "future": {
            "other": "{0}년 후"
          },
          "past": {
            "other": "{0}년 전"
          },
          "-1": "작년"
        },
        "quarter": {
          "0": "이번 분기",
          "1": "다음 분기",
          "future": {
            "other": "{0}분기 후"
          },
          "past": {
            "other": "{0}분기 전"
          },
          "-1": "지난 분기"
        },
        "quarter-short": {
          "0": "이번 분기",
          "1": "다음 분기",
          "future": {
            "other": "{0}분기 후"
          },
          "past": {
            "other": "{0}분기 전"
          },
          "-1": "지난 분기"
        },
        "quarter-narrow": {
          "0": "이번 분기",
          "1": "다음 분기",
          "future": {
            "other": "{0}분기 후"
          },
          "past": {
            "other": "{0}분기 전"
          },
          "-1": "지난 분기"
        },
        "month": {
          "0": "이번 달",
          "1": "다음 달",
          "future": {
            "other": "{0}개월 후"
          },
          "past": {
            "other": "{0}개월 전"
          },
          "-1": "지난달"
        },
        "month-short": {
          "0": "이번 달",
          "1": "다음 달",
          "future": {
            "other": "{0}개월 후"
          },
          "past": {
            "other": "{0}개월 전"
          },
          "-1": "지난달"
        },
        "month-narrow": {
          "0": "이번 달",
          "1": "다음 달",
          "future": {
            "other": "{0}개월 후"
          },
          "past": {
            "other": "{0}개월 전"
          },
          "-1": "지난달"
        },
        "week": {
          "0": "이번 주",
          "1": "다음 주",
          "future": {
            "other": "{0}주 후"
          },
          "past": {
            "other": "{0}주 전"
          },
          "-1": "지난주"
        },
        "week-short": {
          "0": "이번 주",
          "1": "다음 주",
          "future": {
            "other": "{0}주 후"
          },
          "past": {
            "other": "{0}주 전"
          },
          "-1": "지난주"
        },
        "week-narrow": {
          "0": "이번 주",
          "1": "다음 주",
          "future": {
            "other": "{0}주 후"
          },
          "past": {
            "other": "{0}주 전"
          },
          "-1": "지난주"
        },
        "day": {
          "0": "오늘",
          "1": "내일",
          "2": "모레",
          "future": {
            "other": "{0}일 후"
          },
          "past": {
            "other": "{0}일 전"
          },
          "-2": "그저께",
          "-1": "어제"
        },
        "day-short": {
          "0": "오늘",
          "1": "내일",
          "2": "모레",
          "future": {
            "other": "{0}일 후"
          },
          "past": {
            "other": "{0}일 전"
          },
          "-2": "그저께",
          "-1": "어제"
        },
        "day-narrow": {
          "0": "오늘",
          "1": "내일",
          "2": "모레",
          "future": {
            "other": "{0}일 후"
          },
          "past": {
            "other": "{0}일 전"
          },
          "-2": "그저께",
          "-1": "어제"
        },
        "hour": {
          "0": "현재 시간",
          "future": {
            "other": "{0}시간 후"
          },
          "past": {
            "other": "{0}시간 전"
          }
        },
        "hour-short": {
          "0": "현재 시간",
          "future": {
            "other": "{0}시간 후"
          },
          "past": {
            "other": "{0}시간 전"
          }
        },
        "hour-narrow": {
          "0": "현재 시간",
          "future": {
            "other": "{0}시간 후"
          },
          "past": {
            "other": "{0}시간 전"
          }
        },
        "minute": {
          "0": "현재 분",
          "future": {
            "other": "{0}분 후"
          },
          "past": {
            "other": "{0}분 전"
          }
        },
        "minute-short": {
          "0": "현재 분",
          "future": {
            "other": "{0}분 후"
          },
          "past": {
            "other": "{0}분 전"
          }
        },
        "minute-narrow": {
          "0": "현재 분",
          "future": {
            "other": "{0}분 후"
          },
          "past": {
            "other": "{0}분 전"
          }
        },
        "second": {
          "0": "지금",
          "future": {
            "other": "{0}초 후"
          },
          "past": {
            "other": "{0}초 전"
          }
        },
        "second-short": {
          "0": "지금",
          "future": {
            "other": "{0}초 후"
          },
          "past": {
            "other": "{0}초 전"
          }
        },
        "second-narrow": {
          "0": "지금",
          "future": {
            "other": "{0}초 후"
          },
          "past": {
            "other": "{0}초 전"
          }
        }
      }
    },
    "availableLocales": ["ko-KP", "ko"]
  });
}